import React, { Fragment } from 'react'

import Layout from '../components/Layout'
import { SignUpLink, PasswordForgetLink, SignInForm, SignInGoogle, SignInFacebook, SignInTwitter } from '../components/Authentication'

const SignInPage = () => (
    <Fragment>
        <h1>SignIn</h1>
        <SignInForm />
        <SignInGoogle />
        <SignInFacebook />
        <SignInTwitter />
        <PasswordForgetLink />
        <SignUpLink />
    </Fragment>
)

export default ({ location }) => (
    <Layout location={location}>
        <SignInPage />
    </Layout>
)
